import request from '@/utils/request'

export function addStorageReference(entity, item) {
  const method = 'post'
  const url = '/reference/storage'
  return request({
    url,
    method,
    data: item
  })  
}


export function removeStorageReference (entity, item) {
  return request({
    url: '/reference/storage/' + item.id,
    method: 'delete'
  })
}